/** We use this to teleport popup menus to the dialog body */
export const LIBRARY_DIALOG_ID = 'library-dialog'

/**
 * We use this so that the library dialog stays open when the user
 * clicks inside its 'Edit Document' subdialog.
 */
export const EDIT_DOCUMENT_DIALOG_ID = 'edit-document-dialog'
export const CLOSE_LIBRARY_DOCUMENT_DIALOG_ID = 'close-library-document-dialog'
